class ReviewCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.carousel = new Splide(this.querySelector('.splide'),
      {
        arrows: false,
        perPage: 4,
        gap: 'var(--spacing-md)',
        breakpoints: {
          768: {
            perPage: 1.3,
            focus: 0,
          }
        },
      },
    );

    this.carousel.mount();
  }
}

customElements.define('review-carousel', ReviewCarousel);
